export default function (instance) {
  return {
    add_list_photo(payload) {
      return instance.post(
        "reg/add_list_photo",
        {
          foto34_file: payload.foto34_file,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    status(p) {
      return instance.post("reg/status", p);
    },
    status_print(payload) {
      return instance.post("reg/status_print", {
        id_user: payload.id_user,
        status: payload.status,
      });
    },
    status_avn(payload) {
      return instance.post("reg/status_avn", {
        id_user: payload.id_user,
        status: payload.status,
      });
    },
    roles() {
      return instance.post("administrator/roles", {});
    },
    role() {
      return instance.post("administrator/role", {});
    },
    update_roles(p) {
      return instance.post("administrator/update_roles", p);
    },
    reg_user(p) {
      return instance.post("administrator/reg_user", p);
    },

  };
}
